<template>
  <div>
    <h3 class="mb-5">BU Messaging</h3>
    <div class="h4 mb-5">呈現於BU Page置頂區塊</div>
    <div>
      <!-- title -->
      <div class="form-item d-flex pt-3">
        <label class="w-180px mt-5"><h4>Title</h4></label>
        <div class="flex-grow-1 mt-2">
          <v-textarea
            v-model="bu.bu_messaging.title"
            outlined
            dense
          ></v-textarea>
        </div>
      </div>
      <!-- content -->
      <div class="form-item d-flex pt-3">
        <label class="w-180px mt-5"><h4>Content</h4></label>
        <div class="flex-grow-1 mt-2">
          <v-textarea
            v-model="bu.bu_messaging.description"
            outlined
            dense
          ></v-textarea>
        </div>
      </div>
      <!-- background -->
      <div class="d-flex px-5 pt-5 mb-8">
        <div class="w-180px">
          <h4 class="mb-10px">Background</h4>
          <div class="h5 ink-02-medium--text">
            建議尺寸：999px * 999px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="d-flex justify-end flex-grow-1">
          <ImgUploader
            :imageUrl.sync="bu.bu_messaging.image"
            dir="bu_messageing"></ImgUploader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  props: {
    bu: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ImgUploader,
  },
};
</script>

<style></style>
